import { Link, useRouterState } from "@tanstack/react-router";
import { motion, AnimatePresence } from "framer-motion";
import { Logo } from "./Logo";

export function AIFab() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (pathname === "/rosewood-ai") return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.8, y: 16 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.8, y: 16 }}
        transition={{ type: "spring", stiffness: 340, damping: 28, delay: 0.6 }}
        className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2"
      >

        <Link
          to="/rosewood-ai"
          aria-label="Open Rosewood AI tax assistant"
          className="group relative flex items-center gap-2.5
                     bg-gold text-white
                     h-12 px-4 py-2 md:h-14 md:px-5 md:py-2   /* responsive pill sizing */
                     w-auto rounded-full                      /* always pill-shaped */
                     active:scale-95 transition-all duration-200
                     focus-visible:outline-none focus-visible:ring-2
                     focus-visible:ring-[#C9A84C] focus-visible:ring-offset-2"
        >
          <span
            className="absolute inset-0 rounded-full
                       ring-2 ring-[#C9A84C]/40
                       animate-ping opacity-60 pointer-events-none"
            aria-hidden="true"
          />

          <Logo
            size="xs"
            mode="mark"
            variant="light"
            asLink={false}
            className="bg-white rounded-3xl shrink-0"
          />

          <span className="relative text-xs md:text-sm font-semibold tracking-tight whitespace-nowrap">
            Rosewood AI
          </span>
        </Link>
      </motion.div>
    </AnimatePresence>
  );
}
